function Arrow({origin, dir, length, color}) {
    return (
        <>
            <arrowHelper args={[dir, origin, length, color]}/>
        </>
    )
}

export default Arrow;
